import { Redemption } from "../redemption/Redemption";
import { emptyAdminApi } from "./emptyAdminApi";

export type JoyTgtUploadStatus = {
  Status?: string;
  JobId?: string;
  Details?: {
    Imported?: number;
    Skipped?: number;
    Error?: string;
  };
};

const path = "/data-mapping/joy-tgt";

const joyTgtApi = emptyAdminApi.injectEndpoints({
  endpoints: (build) => ({
    swapJoyTgt: build.mutation<Redemption, {
      orderId: string;
      simIdx: number;
      confirmed: boolean;
    }>({
      query: (body) => ({
        url: "/redemptions/joy-tgt/swap",
        method: "POST",
        body,
      }),
    }),
    createJoyTgtUpload: build.mutation<{
      jobId: string;
      uploadUrl: string;
    }, { filename: string }>({
      query: (body) => ({ url: path, method: "POST", body }),
    }),
    getJoyTgtUpload: build.query<JoyTgtUploadStatus, string | undefined>({
      query: (jobId) => ({ url: path, params: { jobId } }),
    }),
  }),
});

export const {
  useSwapJoyTgtMutation,
  useCreateJoyTgtUploadMutation,
  useGetJoyTgtUploadQuery,
} = joyTgtApi;
